import { render, staticRenderFns } from "./BeltBenefitLayout.vue?vue&type=template&id=ff366d2e&scoped=true&"
import script from "./BeltBenefitLayout.vue?vue&type=script&lang=js&"
export * from "./BeltBenefitLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff366d2e",
  null
  
)

export default component.exports